import React, { useEffect, useState, useMemo } from "react";
import { Row } from "antd";
import { useGlobal } from "../../../../store/index";
import ProductsCard from "../ProductsCard";
import AlgoliaFilters from "../../AlgoliaFilters/App";
import {
  connectHits,
  createInfiniteHitsSessionStorageCache,
} from "react-instantsearch-dom";

const InfiniteHits = ({
  hits,
  hasPrevious,
  refinePrevious,
  hasMore,
  refineNext,
}) => (
  <div>
    <Row>
      {hits.map((item, index) => (
        <ProductsCard item={item} key={index} index={index} />
      ))}
    </Row>
  </div>
);

const CustomInfiniteHits = connectHits(InfiniteHits);

export default function AllProducts() {
  const [globalState, setGlobalState] = useGlobal();
  const [productsData, setProductsData] = useState([]);

  const { filters, products } = globalState;
  const fields =
    "*, colours.colours_id.name,colours.colours_id.hexcode, product_images.directus_files_id,secondary_category.id,secondary_category.name";

  useEffect(() => {
    return () => {
      setGlobalState.products.clearProducts();
      setProductsData((prevState) => []);
    };
  }, [setGlobalState]);

  useEffect(() => {
    if (products) {
      setProductsData((prevState) => [...products?.data]);
    }
  }, [products]);

  const sessionStorageCache = createInfiniteHitsSessionStorageCache();

  const comp = useMemo(() => {
    return (
      <AlgoliaFilters
        Hits={<CustomInfiniteHits cache={sessionStorageCache} />}
        primaryText="All Products"
      />
    );
  }, []);

  return <>{comp}</>;
}
